<template>
    <div class="light-color-bg position-relative">
        <QuestionTitle number="07" :question="question" @activateModal="modalActive=true" :modalActivator="true" :modalActive="modalActive"></QuestionTitle>
        <div class="container-70 mt-20px">
            <SelectOptionBox :img="imgRecycling" :options="optionsRecycling" v-model="result['recycling']" class="z-3000"></SelectOptionBox>
            <SelectOptionBox :img="imgCompost" :options="optionsCompost" v-model="result['compost']" class="mt-40px z-2000"></SelectOptionBox>
            <SelectOptionBox :img="imgZeroDechet" :options="optionsZeroDechet" v-model="result['zeroDechet']" class="mt-40px z-1000"></SelectOptionBox>
            <div v-if="result != null" @click="saveAndContinue('matiereResiduelleCitoyen', JSON.stringify(result), '/resultats')"
                class="btn-primary d-block w-100 mt-50px text-center">Suivant</div>
            <AvancementLine class="mt-50px" percent="80%"></AvancementLine>
        </div>
        <ModalInfo @closeModal="modalActive = false" v-if="modalActive">
            <h3 class="modal-title">GES émis par votre production de matières résiduelles</h3>
            <p class="modal-text">Non seulement les déchets que nous produisons polluent notre environnement, mais s'ils ne sont pas jetés au bon endroit, comme jeter sa pelure de banane à la poubelle plutôt qu'au compost, ils émettent encore plus de GES. L'adoption du principe des 3RV permet de réduire notre empreinte carbone en priorisant, dans l'ordre, la réduction de notre consommation, la réutilisation des matières qu'on possède déjà ou qui sont déjà sur le marché du seconde main, le recyclage puis la valorisation de nos déchets.</p>
        </ModalInfo>
    </div>
</template>
<script>
import QuestionTitle from '@/components/QuestionTitle.vue'
import AvancementLine from '@/components/AvancementLine.vue'
import SelectOptionBox from '@/components/SelectOptionBox.vue'
import ModalInfo from '@/components/ModalInfo.vue'
/*Mixins*/
import utils from '@/mixins/utils'
export default {
    data() {
        return {
            result: {
                recycling:null,
                compost:null,
                zeroDechet:null
            },
            modalActive:false,
            question: 'Indiquez, au meilleur de vos connaissances, vos habitudes de gestion des matières résiduelles à la maison.',
            imgRecycling: require('@/assets/images/recycling.png'),
            optionsRecycling: [
                {
                    label: "Oui",
                    value: "Oui"
                },
                {
                    label: "Parfois",
                    value: "Parfois"
                },
                {
                    label: "Non",
                    value: "Non"
                }
            ],
            imgCompost: require('@/assets/images/compost.png'),
            optionsCompost: [
                {
                    label: "Oui",
                    value: "Oui"
                },
                {
                    label: "Parfois",
                    value: "Parfois"
                },
                {
                    label: "Non",
                    value: "Non"
                }
            ],
            imgZeroDechet: require('@/assets/images/zerodechet.png'),
            optionsZeroDechet: [
                {
                    label: "Oui, elle est très avancée",
                    value: "Oui, elle est très avancée"
                },
                {
                    label: "Je pose quelques actions en ce sens",
                    value: "Je pose quelques actions en ce sens"
                },
                {
                    label: "Non",
                    value: "Non"
                }
            ]

        }
    },
    components: {
        QuestionTitle,
        AvancementLine,
        SelectOptionBox,
        ModalInfo
    },
    mixins: [utils],
    mounted() {
        if (sessionStorage.getItem('matiereResiduelleCitoyen')) {
            this.result = JSON.parse(sessionStorage.getItem('matiereResiduelleCitoyen'))
        }
    }
}
</script>
<style scoped>
.z-3000{
   z-index:3000; 
}
.z-2000{
    z-index:2000; 
}
.z-1000{
    z-index:1000; 
}

</style>